import Dashboard from "../../common/components/layout/Dashboard";
import Toast from "../../common/components/ui/toast";
import { ToastProvider } from "../../common/components/ui/toast/toast.provider";
import TablePartners from "./components/table-partners/TablePartners";

export function PartnerRegisterPage() {

    return (
        <ToastProvider>
            <Dashboard>
                <TablePartners />
            </Dashboard>
            <Toast />
        </ToastProvider>
    )
}